
import { inject } from "vue";
import $ from "jquery";
import Vue, { onMounted, ref, getCurrentInstance, reactive, watch } from "vue";
import { useRouter } from "vue-router";
export default {
  setup(props) {
    let router = useRouter();

    let show = ref<any>(false);
    let inputValue = ref<any>("");
    let checkShow = ref<any>(true);
    let checkShow1 = ref<any>(false);
    let checkShow2 = ref<any>(false);
    let checkShow3 = ref<any>(false);
    let checkShow4 = ref<any>(false);
    let checkShow5 = ref<any>(false);
    let checkShow6 = ref<any>(false);

    let check = ref<any>(false);
    const refresh = inject<any>("reload");
    let block = ref<any>("block");
    //获取全局变量
    let proxy = getCurrentInstance() as any;
    console.log("proxy11", proxy);
    if (window.sessionStorage.getItem("language") as string) {
      let lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
      if (lan == "EN") {
        show.value = true;
      }
    }
     if(window.name == ""){
           console.log("首次被加载");
       // 在首次进入页面时我们给window.name设置一个固定值(isRefresh) 
           window.name = "isRefresh"; 
       }else if(window.name == "isRefresh"){
           console.log("页面被刷新");
       }


    router.beforeEach((to, from, next) => {
      //  console.log("from",from)
      //    console.log("to",to)
 window.sessionStorage.setItem(
          "route",
          JSON.stringify(to.name)
        );
      if (to.name == "homePage") {
        goLink(1, 1);
      } else if (to.name == "aboutUs") {
        goLink(2, 1);
      } else if (to.name == "researchInnovation") {
        goLink(3, 1);
      } else if (to.name == "technologicalFrontier") {
        goLink(4, 1);
      } else if (to.name == "internationalCooperation") {
        goLink(5, 1);
      } else if (to.name == "news") {
        goLink(6, 1);
      } else if (to.name == "committeeExperts") {
        goLink(7, 1);
      } else if (from.name == "homePage" && to.name == "article") {
        goLink(4, 1);
      }

      next();
    });
    const changeLanuange = (num) => {
      if (num == 1) {
        // proxy.appContext.config.globalProperties.$language = "EN";
        let language = "EN";
        show.value = true;
        //在方法体中的调用方法
        window.sessionStorage.setItem("language", JSON.stringify(language));
      } else {
        // proxy.appContext.config.globalProperties.$language = "CN";
        let language = "CN";
        show.value = false;
        window.sessionStorage.setItem("language", JSON.stringify(language));
      }

      location.reload();
    };

    const change = (index) => {
      console.log("2222", inputValue.value);
      router.push({
        path: "/search" + "/" + inputValue.value,
      });
    };

    const goLink = (index, num) => {
      if (index == 1) {
        checkShow.value = true;
        checkShow1.value = false;
        checkShow2.value = false;
        checkShow3.value = false;
        checkShow4.value = false;
        checkShow5.value = false;
        checkShow6.value = false;
        if (!num) {
          router.push({ path: "/" });
        }
      } else if (index == 2) {
        if (!num) {
          router.push({ path: "/aboutUs" });
        }
        checkShow1.value = true;
        checkShow.value = false;
        checkShow2.value = false;
        checkShow3.value = false;
        checkShow4.value = false;
        checkShow5.value = false;
        checkShow6.value = false;
      } else if (index == 3) {
        checkShow2.value = true;
        checkShow1.value = false;
        checkShow.value = false;
        checkShow3.value = false;
        checkShow4.value = false;
        checkShow5.value = false;
        checkShow6.value = false;
        if (!num) {
          router.push({ path: "/researchInnovation" });
        }
      } else if (index == 4) {
        checkShow3.value = true;
        checkShow1.value = false;
        checkShow2.value = false;
        checkShow.value = false;
        checkShow4.value = false;
        checkShow5.value = false;
        checkShow6.value = false;
        if (!num) {
          router.push({ path: "/technologicalFrontier" });
        }
      } else if (index == 5) {
        checkShow4.value = true;
        checkShow1.value = false;
        checkShow2.value = false;
        checkShow3.value = false;
        checkShow.value = false;
        checkShow5.value = false;
        checkShow6.value = false;
        if (!num) {
          router.push({ path: "/internationalCooperation" });
        }
      } else if (index == 6) {
        checkShow5.value = true;
        checkShow1.value = false;
        checkShow2.value = false;
        checkShow3.value = false;
        checkShow4.value = false;
        checkShow.value = false;
        checkShow6.value = false;
        if (!num) {
          router.push({ path: "/news" });
        }
      } else if (index == 7) {
        checkShow6.value = true;
        checkShow1.value = false;
        checkShow2.value = false;
        checkShow3.value = false;
        checkShow4.value = false;
        checkShow5.value = false;
        checkShow.value = false;
        if (!num) {
          router.push({ path: "/committeeExperts" });
        }
      }

      let screenWidth = document.body.clientWidth;
      console.log("screenWidth", screenWidth);
      //菜单切换
      if (screenWidth < 600) {
        $("#panel").slideToggle("slow");
      }
    };


if(window.sessionStorage.getItem("route") as string){
  if(window.name == "isRefresh"){
        let name = JSON.parse(window.sessionStorage.getItem("route") as string);
        console.log("name",name)
        if (name == "homePage") {
        goLink(1, 1);
      } else if (name == "aboutUs") {
        goLink(2, 1);
      } else if (name == "researchInnovation") {
        goLink(3, 1);
      } else if (name == "technologicalFrontier") {
        goLink(4, 1);
      } else if (name == "internationalCooperation") {
        goLink(5, 1);
      } else if (name == "news") {
        goLink(6, 1);
      } else if (name == "committeeExperts") {
        goLink(7, 1);
      } else if ( name == "article") {
        goLink(4, 1);
      }
       }
  
}





    //菜单切换
    $(document).ready(function () {
      $("#flip").click(function () {
        $("#panel").slideToggle("slow");
      });
    });

    return {
      change,
      goLink,
      block,
      refresh,
      changeLanuange,
      proxy,
      show,
      check,
      inputValue,
      checkShow,
      checkShow1,
      checkShow2,
      checkShow3,
      checkShow4,
      checkShow5,
      checkShow6,
    };
  },
};
